/* src/app/modules/shared/components/search-article/search-article.component.scss */
.example-option-img {
  vertical-align: middle;
  margin-right: 3px;
  border-radius: 100%;
}
/*# sourceMappingURL=search-article.component.css.map */
